import { Box, Card, CardContent, Grid, Skeleton } from "@mui/joy";

export function LaborSkeleton() {
    return (
        <Box>
            {/* Header Section */}
            <Box mb={2.5}>
                <Skeleton variant="text" width={240} height={28} />
                <Skeleton variant="text" width={420} height={20} sx={{ mt: 0.5 }} />
            </Box>

            {/* Labor cards skeleton */}
            <Grid container spacing={1.5}>
                {[1, 2, 3, 4].map((index) => (
                    <Grid xs={12} key={index}>
                        <Card
                            sx={{
                                p: 1.5,
                                px: 2,
                                borderRadius: "md",
                                border: "1px solid",
                                borderColor: "divider",
                            }}
                            variant="soft"
                        >
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" gap={3}>
                                    {/* Left section - Labor info */}
                                    <Box flex={1} display="flex" flexDirection="column" justifyContent="center" gap={1}>
                                        <Skeleton variant="text" width={180} height={20} />
                                        <Skeleton variant="text" width={140} height={16} />
                                    </Box>

                                    {/* Middle section - Quantity control */}
                                    <Box display="flex" alignItems="center">
                                        <Skeleton
                                            variant="rectangular"
                                            width={100}
                                            height={36}
                                            sx={{ borderRadius: "20px" }}
                                        />
                                    </Box>

                                    {/* Right section - Price */}
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="center"
                                        minWidth={140}
                                        gap={0.5}
                                    >
                                        <Skeleton variant="text" width={70} height={18} />
                                        <Skeleton variant="text" width={90} height={14} />
                                    </Box>

                                    {/* Remove button */}
                                    <Box display="flex" alignItems="center">
                                        <Skeleton variant="circular" width={24} height={24} />
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Supplier comparison skeleton */}
            <Box mt={4}>
                <Box mb={2}>
                    <Skeleton variant="text" width={180} height={24} />
                    <Skeleton variant="text" width={320} height={16} sx={{ mt: 0.5 }} />
                </Box>
                <Card variant="outlined" sx={{ p: 1 }}>
                    <Skeleton variant="rectangular" width="100%" height={240} sx={{ borderRadius: "sm" }} />
                </Card>
            </Box>
        </Box>
    );
}
